module.exports = __webpack_public_path__ + "img/addClassification.f02c542a.svg";